import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccessState } from '@core/frontend-shared';
import { Select, Store } from '@ngxs/store';
import { takeWhileAlive } from '@core/frontend-shared/utils';

import { UiInputSelectButtonComponent } from '@common/ui/frontend-shared/input-selectbutton';
import { LayoutFrontpageComponent } from '@pflegetheke/ui/frontend-shared/layout-frontpage';
import { UiRequiredModule } from '@pflegetheke/ui/frontend-shared';
import { FeedbackButtonComponent } from '@common/feedback/frontend';
import { CoreFrontendSharedModule } from '@core/frontend-shared';
import { UiInputDropdownBundle } from '@common/ui/frontend-shared/input-dropdown';
import { UiTabViewComponent, UiTabViewBundle } from '@common/ui/frontend-shared/tabview';
import { MembershipFrontendSharedModule } from '@common/membership/frontend-shared';
import { UserAuthenticationStrategiesComponent } from '@common/users/frontend-shared';

@Component({
    selector: 'pflegetheke-login',
    styleUrls: ['./login.component.scss'],
    template: `
	<pflegetheke-layout-frontpage theme="green" [showBottomButtons]="false">
		<!-- <a class="top-menu-item" routerLink="/privacy" >Datenschutz</a>
		<a class="top-menu-item" routerLink="/imprint" >Impressum</a> -->
		<feedback-button class="top-menu-item"  buttonClass=""></feedback-button>	

		<div class="content-left">
			<!-- <h2>Die <b>einfache Lösung</b><br> für Ihr Team.</h2> -->
		</div>
		<div class="content-right">
			<div>
			<ui-tabView [(activeIndex)]="activeTabIndex" #tabView>
				<ui-tabPanel header="Login" name="login">
						<user-authentication-strategies></user-authentication-strategies>
					<p class="ui-margin-large ui-text-center">Noch kein Account vorhanden? <a (click)="onClickRegisterNow()">Jetzt registrieren</a></p>
				</ui-tabPanel>
				<ui-tabPanel header="Registrierung" name="registration">
					<membership-registration-wrapper [inline]="true"></membership-registration-wrapper>
				</ui-tabPanel>
			</ui-tabView>
			</div>
		</div>
		<ui-card size="large">
		</ui-card>
	</pflegetheke-layout-frontpage>
	`,
    imports: [
    UiInputSelectButtonComponent,
    LayoutFrontpageComponent,
    UiRequiredModule,
    FeedbackButtonComponent,
    UiInputDropdownBundle,
    CoreFrontendSharedModule,
    UiTabViewBundle,
    MembershipFrontendSharedModule,
    UserAuthenticationStrategiesComponent
]
})
export class AppLoginComponent {

	activeTabIndex = 0;

	loggedIn$ = inject(Store).select(AccessState.loggedIn) 
	@ViewChild('tabView') tabView!: UiTabViewComponent;

	constructor(
		router:Router,
		private route:ActivatedRoute,
		private cd:ChangeDetectorRef,
	) {
		
		// navigate to home if user is already logged in
		this.loggedIn$.pipe(takeWhileAlive()).subscribe(loggedIn=>{
			if(loggedIn) router.navigate(['/'])
		})
	}

	ngAfterViewInit() {
		const params = this.route.snapshot.queryParams;
		if(params['tab']) {
			const selectedIndex = this.tabView.findTabIndexByName(params['tab'])	
			if (selectedIndex !== null) this.activeTabIndex = selectedIndex;
			// for some reason, markForCheck is not enough here to fix ExpressionHasBeenChanged error
			this.cd.detectChanges();
		}
	}

	onClickRegisterNow() {
		this.activeTabIndex = 1;
	}

}
